import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'



export const getDaftarVendor = createAsyncThunk('/daftar_vendor/content', async (nopage) => {
    const userId = localStorage.getItem("userId");
    
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/daftarvendor/${userId}?page=${nopage}`, {})
    
    return response.data;
})

export const daftarvendorSlice = createSlice({
    name: 'daftar_vendor',
    initialState: {
        isLoading: false,
        daftar_vendor : []
    },

    /*extraReducers: {
        [getDaftarVendor.pending]: state => {
			state.isLoading = true
		},
        [getDaftarVendor.fulfilled]: (state, action) => {
            state.daftar_vendor = action.payload.data
			state.isLoading = false
		},
        [getDaftarVendor.rejected]: state => {
			state.isLoading = false
		},
    }*/

    extraReducers: (builder) => {
        builder
          .addCase(getDaftarVendor.pending, (state) => {
            state.isLoading = true;
          })
          .addCase(getDaftarVendor.fulfilled, (state, action) => {
            state.daftar_vendor = action.payload.data;
            state.isLoading = false;
          })
          .addCase(getDaftarVendor.rejected, (state) => {
            state.isLoading = false;
          });
      }
})


export default daftarvendorSlice.reducer